// First Created - 08 Oct 2026
// Author - Atul Pandey
// Purpose - Create Session Reference Content

import React from "react"

import {
    useNavigate,
} from "react-router"

import useTitle from "@/hooks/useTitle"

import {
    useCreateSessionReferenceContentMutation,
} from "./sessionReferenceContentApiSlice"

import EtSessionReferenceContentForm
    from "./EtSessionReferenceContentForm"


/*
|--------------------------------------------------------------------------
| 01 - Main Component
|--------------------------------------------------------------------------
*/

const EtCreateSessionReferenceContent = ({
    setActiveAdminView,
}) => {

    useTitle(
        "Create Session Reference Content"
    )

    const navigate = useNavigate()


    /*
    |--------------------------------------------------------------------------
    | 02 - Create Mutation
    |--------------------------------------------------------------------------
    */

    const [
        createSessionReferenceContent,
        {
            isLoading,
        },
    ] = useCreateSessionReferenceContentMutation()


    /*
    |--------------------------------------------------------------------------
    | 03 - Return To List
    |--------------------------------------------------------------------------
    */

    const returnToList = () => {

        if (setActiveAdminView) {

            setActiveAdminView(
                "sessionReferenceContent"
            )

        } else {

            navigate(
                "/sessionReferenceContent"
            )

        }

    }


    /*
    |--------------------------------------------------------------------------
    | 04 - Create Content
    |--------------------------------------------------------------------------
    */

    const handleSave = async payload => {

        const response =
            await createSessionReferenceContent(
                payload
            ).unwrap()

        alert(
            response?.message ||
            "Session Reference Content created successfully"
        )

        returnToList()

    }


    /*
    |--------------------------------------------------------------------------
    | 05 - Render
    |--------------------------------------------------------------------------
    */

    return (

        <EtSessionReferenceContentForm
            formTitle="Add Session Reference Content"
            submitLabel="Create"
            isSaving={isLoading}
            onSave={handleSave}
            onCancel={returnToList}
        />

    )

}


export default EtCreateSessionReferenceContent